export default __webpack_public_path__ + "static/media/addresses-image.904a55a6.svg";